import React from 'react';
import Footer from '../components/Footer';

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="mx-auto max-w-4xl px-6 py-16">
        <h1 className="text-3xl font-bold text-gray-900">Privacy Policy</h1>
        <p className="mt-2 text-sm text-gray-500">Last updated: February 11, 2026</p>

        <section className="mt-8 space-y-4 text-gray-700">
          <p>
            Together On Mission (the &quot;App&quot;) helps users manage discipleship
            relationships, messages, stories, and community features. This policy explains
            what information we collect and how we use it.
          </p>
        </section>

        <section className="mt-10 space-y-3 text-gray-700">
          <h2 className="text-xl font-semibold text-gray-900">Information We Collect</h2>
          <ul className="list-disc pl-6 space-y-2">
            <li>Account details such as name and email address.</li>
            <li>Profile content you choose to add (photos, bio, preferences).</li>
            <li>Community content you submit (stories, comments, prayer requests).</li>
            <li>Contacts only if you grant permission to import them.</li>
            <li>Usage data needed to operate the app (notifications, reminders).</li>
          </ul>
        </section>

        <section className="mt-10 space-y-3 text-gray-700">
          <h2 className="text-xl font-semibold text-gray-900">How We Use Information</h2>
          <ul className="list-disc pl-6 space-y-2">
            <li>Provide core app functionality and account access.</li>
            <li>Enable community features and organization participation.</li>
            <li>Send reminders and notifications you opt into.</li>
            <li>Maintain security and prevent abuse.</li>
          </ul>
        </section>

        <section className="mt-10 space-y-3 text-gray-700">
          <h2 className="text-xl font-semibold text-gray-900">Data Sharing</h2>
          <p>
            We do not sell personal information. We share data only with service providers
            that help operate the app (such as hosting, email, and messaging) and only as
            required to deliver the service.
          </p>
        </section>

        <section className="mt-10 space-y-3 text-gray-700">
          <h2 className="text-xl font-semibold text-gray-900">Your Choices</h2>
          <ul className="list-disc pl-6 space-y-2">
            <li>Update your profile at any time.</li>
            <li>Control notification preferences in settings.</li>
            <li>Request deletion of your account by contacting support.</li>
          </ul>
        </section>

        <section className="mt-10 space-y-3 text-gray-700">
          <h2 className="text-xl font-semibold text-gray-900">Contact</h2>
          <p>
            Questions about privacy? Email us at
            {' '}
            <a className="text-blue-600 hover:underline" href="mailto:support@togetheronmission.org">
              support@togetheronmission.org
            </a>.
          </p>
        </section>
      </div>
      <Footer />
    </div>
  );
};

export default PrivacyPolicy;
